import { useState } from "react";

const shareCards = [
  {
    name: "Round Brilliant",
    tagline: "The Classic Standard",
    image:
      "https://readdy.ai/api/search-image?query=Round%20brilliant%20cut%20diamond%20solitaire%20ring%20in%20classic%20gold%20six%20prong%20setting%20centered%20on%20pure%20black%20background%20with%20subtle%20gold%20decorative%20border%20frame%2C%20luxury%20jewelry%20social%20media%20card%20design%2C%20dramatic%20studio%20lighting%20with%20sparkling%20facets%2C%20portrait%20orientation%2C%20elegant%20minimal%20dark%20composition%2C%20high%20contrast%2C%20ultra%20high%20detail%20professional%20photography&width=1080&height=1350&seq=share-round&orientation=portrait",
  },
  {
    name: "Oval",
    tagline: "Elongated Grace",
    image:
      "https://readdy.ai/api/search-image?query=Oval%20cut%20diamond%20engagement%20ring%20in%20elegant%20gold%20setting%20centered%20on%20pure%20black%20background%20with%20subtle%20gold%20decorative%20border%20frame%2C%20elongated%20graceful%20shape%2C%20luxury%20jewelry%20social%20media%20card%20design%2C%20dramatic%20lighting%20with%20sparkling%20facets%2C%20portrait%20orientation%2C%20elegant%20minimal%20dark%20composition%2C%20high%20contrast%2C%20ultra%20high%20detail%20professional%20photography&width=1080&height=1350&seq=share-oval&orientation=portrait",
  },
  {
    name: "Emerald",
    tagline: "Step-Cut Sophistication",
    image:
      "https://readdy.ai/api/search-image?query=Emerald%20cut%20diamond%20engagement%20ring%20in%20gold%20setting%20centered%20on%20pure%20black%20background%20with%20subtle%20gold%20decorative%20border%20frame%2C%20rectangular%20step%20cut%20facets%2C%20hall%20of%20mirrors%20effect%2C%20luxury%20jewelry%20social%20media%20card%20design%2C%20dramatic%20lighting%2C%20portrait%20orientation%2C%20elegant%20minimal%20dark%20composition%2C%20high%20contrast%2C%20ultra%20high%20detail%20professional%20photography&width=1080&height=1350&seq=share-emerald&orientation=portrait",
  },
  {
    name: "Princess",
    tagline: "Modern Angular Fire",
    image:
      "https://readdy.ai/api/search-image?query=Princess%20cut%20diamond%20solitaire%20ring%20in%20gold%20setting%20centered%20on%20pure%20black%20background%20with%20subtle%20gold%20decorative%20border%20frame%2C%20square%20shape%20with%20pointed%20corners%2C%20brilliant%20facets%20sparkling%2C%20luxury%20jewelry%20social%20media%20card%20design%2C%20dramatic%20lighting%2C%20portrait%20orientation%2C%20elegant%20minimal%20dark%20composition%2C%20high%20contrast%2C%20ultra%20high%20detail%20professional%20photography&width=1080&height=1350&seq=share-princess&orientation=portrait",
  },
  {
    name: "Cushion",
    tagline: "Romantic Vintage Charm",
    image:
      "https://readdy.ai/api/search-image?query=Cushion%20cut%20diamond%20engagement%20ring%20in%20gold%20setting%20centered%20on%20pure%20black%20background%20with%20subtle%20gold%20decorative%20border%20frame%2C%20rounded%20square%20corners%2C%20romantic%20vintage%20style%2C%20sparkling%20facets%2C%20luxury%20jewelry%20social%20media%20card%20design%2C%20dramatic%20lighting%2C%20portrait%20orientation%2C%20elegant%20minimal%20dark%20composition%2C%20high%20contrast%2C%20ultra%20high%20detail%20professional%20photography&width=1080&height=1350&seq=share-cushion&orientation=portrait",
  },
  {
    name: "Pear",
    tagline: "Teardrop Distinction",
    image:
      "https://readdy.ai/api/search-image?query=Pear%20cut%20diamond%20teardrop%20shape%20solitaire%20ring%20in%20gold%20setting%20centered%20on%20pure%20black%20background%20with%20subtle%20gold%20decorative%20border%20frame%2C%20rounded%20base%20with%20tapered%20point%2C%20unique%20dramatic%20shape%2C%20luxury%20jewelry%20social%20media%20card%20design%2C%20sparkling%20facets%2C%20dramatic%20lighting%2C%20portrait%20orientation%2C%20elegant%20minimal%20dark%20composition%2C%20high%20contrast%2C%20ultra%20high%20detail%20professional%20photography&width=1080&height=1350&seq=share-pear&orientation=portrait",
  },
  {
    name: "Marquise",
    tagline: "Regal Elongation",
    image:
      "https://readdy.ai/api/search-image?query=Marquise%20cut%20diamond%20solitaire%20ring%20in%20gold%20setting%20centered%20on%20pure%20black%20background%20with%20subtle%20gold%20decorative%20border%20frame%2C%20elongated%20shape%20with%20pointed%20ends%2C%20dramatic%20regal%20style%2C%20sparkling%20brilliant%20facets%2C%20luxury%20jewelry%20social%20media%20card%20design%2C%20dramatic%20lighting%2C%20portrait%20orientation%2C%20elegant%20minimal%20dark%20composition%2C%20high%20contrast%2C%20ultra%20high%20detail%20professional%20photography&width=1080&height=1350&seq=share-marquise&orientation=portrait",
  },
  {
    name: "Asscher",
    tagline: "Art Deco Precision",
    image:
      "https://readdy.ai/api/search-image?query=Asscher%20cut%20diamond%20solitaire%20ring%20in%20gold%20setting%20centered%20on%20pure%20black%20background%20with%20subtle%20gold%20decorative%20border%20frame%2C%20square%20step%20cut%20with%20cropped%20corners%2C%20art%20deco%20style%2C%20hall%20of%20mirrors%20facets%2C%20luxury%20jewelry%20social%20media%20card%20design%2C%20dramatic%20lighting%2C%20portrait%20orientation%2C%20elegant%20minimal%20dark%20composition%2C%20high%20contrast%2C%20ultra%20high%20detail%20professional%20photography&width=1080&height=1350&seq=share-asscher&orientation=portrait",
  },
  {
    name: "Radiant",
    tagline: "Brilliant Square Fusion",
    image:
      "https://readdy.ai/api/search-image?query=Radiant%20cut%20diamond%20solitaire%20ring%20in%20gold%20setting%20centered%20on%20pure%20black%20background%20with%20subtle%20gold%20decorative%20border%20frame%2C%20square%20shape%20with%20brilliant%20facets%20and%20trimmed%20corners%2C%20luxury%20jewelry%20social%20media%20card%20design%2C%20dramatic%20lighting%2C%20sparkling%20facets%2C%20portrait%20orientation%2C%20elegant%20minimal%20dark%20composition%2C%20high%20contrast%2C%20ultra%20high%20detail%20professional%20photography&width=1080&height=1350&seq=share-radiant&orientation=portrait",
  },
];

async function downloadImage(url: string, filename: string) {
  try {
    const res = await fetch(url);
    const blob = await res.blob();
    const blobUrl = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(blobUrl);
  } catch {
    window.open(url, "_blank");
  }
}

function DownloadCard({ card }: { card: (typeof shareCards)[0] }) {
  const [downloading, setDownloading] = useState(false);

  const handleDownload = async () => {
    setDownloading(true);
    await downloadImage(
      card.image,
      `Zayan_${card.name.replace(/\s+/g, "_")}_Share_Card.jpg`
    );
    setDownloading(false);
  };

  return (
    <div className="border border-zayan-border hover:border-zayan-gold/40 transition-all duration-500 group">
      <div className="relative overflow-hidden aspect-[4/5]">
        <img
          src={card.image}
          alt={`${card.name} share card`}
          className="w-full h-full object-cover object-top group-hover:scale-[1.02] transition-transform duration-700"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-zayan-bg/70 via-transparent to-transparent" />
        <div className="absolute bottom-4 left-4 right-4">
          <p className="text-zayan-gold text-[10px] tracking-[0.2em] uppercase font-sans mb-1">
            {card.tagline}
          </p>
          <h4 className="font-serif text-xl text-zayan-gold">{card.name}</h4>
        </div>
      </div>
      <div className="p-4 border-t border-zayan-border">
        <button
          onClick={handleDownload}
          disabled={downloading}
          className="w-full flex items-center justify-center gap-2 border border-zayan-gold bg-zayan-gold/10 text-zayan-gold px-4 py-2.5 text-[11px] tracking-[0.15em] hover:bg-zayan-gold hover:text-zayan-bg transition-colors disabled:opacity-50 cursor-pointer whitespace-nowrap"
        >
          {downloading ? (
            <i className="ri-loader-4-line animate-spin" />
          ) : (
            <i className="ri-download-line" />
          )}
          {downloading ? "DOWNLOADING..." : "DOWNLOAD CARD"}
        </button>
      </div>
    </div>
  );
}

export default function ShareCardsGallery() {
  const [batchLoading, setBatchLoading] = useState(false);

  const handleDownloadAll = async () => {
    setBatchLoading(true);
    for (const card of shareCards) {
      await downloadImage(
        card.image,
        `Zayan_${card.name.replace(/\s+/g, "_")}_Share_Card.jpg`
      );
      // Small delay to avoid overwhelming the browser
      await new Promise((r) => setTimeout(r, 400));
    }
    setBatchLoading(false);
  };

  return (
    <section className="border-t border-zayan-border py-16 md:py-20 lg:py-24 px-6 lg:px-16">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <p className="text-zayan-gold text-xs tracking-[0.2em] uppercase mb-3 font-sans">
            Shareable Content
          </p>
          <h2 className="font-serif text-3xl md:text-4xl text-zayan-gold mb-4">
            Download & Share
          </h2>
          <p className="text-zayan-textMuted text-sm max-w-xl mx-auto mb-8">
            Ready-to-share cards featuring each diamond cut. Perfect for Instagram, Pinterest, or any social platform. Click to download instantly.
          </p>
          <button
            onClick={handleDownloadAll}
            disabled={batchLoading}
            className="inline-flex items-center gap-2 border border-zayan-gold/50 text-zayan-textMuted px-6 py-2.5 text-[11px] tracking-[0.15em] hover:border-zayan-gold hover:text-zayan-gold transition-colors disabled:opacity-50 cursor-pointer whitespace-nowrap"
          >
            {batchLoading ? (
              <i className="ri-loader-4-line animate-spin" />
            ) : (
              <i className="ri-download-cloud-line" />
            )}
            {batchLoading ? "DOWNLOADING ALL..." : "DOWNLOAD ALL 9 CARDS"}
          </button>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {shareCards.map((card, i) => (
            <DownloadCard key={i} card={card} />
          ))}
        </div>
      </div>
    </section>
  );
}